import { connect } from 'react-redux';
import { getAffiliatesDataIfNeeded } from '../actions/affiliatesAction';
import AffiliatesComponent from '../components/affiliatesComponent';

const mapStateToProps = (state) => ({
    dataAffiliates: state.affiliates.dataAffiliates,
});

const mapDispatchToProps = (dispatch) => ({
    getAffiliatesDataIfNeeded: () => dispatch(getAffiliatesDataIfNeeded()),
});

const AffiliatesContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(AffiliatesComponent);

export default AffiliatesContainer;
